export default __webpack_public_path__ + "420c1f5a76cf4da6e1c91217d8ebadbb.jpg";